import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  Pressable,
  Image,
} from 'react-native';
import { VertivContainer } from '../components';
import { useAuth } from '../contexts/AuthContext';

interface UnauthorizedAccessProps {
  onRequestAccess?: () => void;
}

export const UnauthorizedAccess: React.FC<UnauthorizedAccessProps> = ({ 
  onRequestAccess 
}) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  const handleRequestAccess = () => {
    if (onRequestAccess) {
      onRequestAccess();
    } else {
      // TODO: Implement request access workflow
    }
  };

  return (
    <VertivContainer>
      <View style={styles.contentCard}>
        <View style={styles.logoContainer}>
          <Image 
            source={require('../assets/vertiv-logo-black.png')}
            style={styles.logo}
            resizeMode="contain"
          />
        </View>
        
        <Text testID="unauthorized-access-title" style={styles.title}>Access Not Authorized</Text>
        
        <Text style={styles.message}>
          You don't have the necessary permissions to access the Vertiv Site Scope.
        </Text>

        {user && (
          <View style={styles.userInfo}>
            <Text style={styles.userInfoLabel}>Logged in as:</Text>
            <Text style={styles.userInfoText}>{user.name}</Text>
            <Text style={styles.userInfoText}>{user.email}</Text>
          </View>
        )}
        
        <View style={styles.actionContainer}>
          <Pressable
            style={styles.requestButton}
            onPress={handleRequestAccess}
          >
            <Text style={styles.requestButtonText}>Request Access</Text>
          </Pressable>
          
          <Pressable
            style={styles.logoutButton}
            onPress={handleLogout}
          >
            <Text style={styles.logoutButtonText}>Sign Out</Text>
          </Pressable>
        </View>

        <Text style={styles.helpText}>
          If you believe you should have access, please contact your administrator or request access using the button above.
        </Text>
      </View>
    </VertivContainer>
  );
};

const styles = StyleSheet.create({
  contentCard: {
    width: '100%',
    maxWidth: 440,
    alignItems: 'center',
    padding: 40,
    backgroundColor: '#fff',
    borderRadius: 8,
  },
  logoContainer: {
    marginBottom: 32,
    alignItems: 'center',
  },
  logo: {
    width: 80,
    height: 80,
  },
  title: {
    fontSize: 24,
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: 16,
    color: '#1a1a1a',
  },
  message: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 24,
    color: '#666',
    lineHeight: 20,
  },
  userInfo: {
    width: '100%',
    padding: 16,
    backgroundColor: '#f8f9fa',
    borderRadius: 4,
    marginBottom: 24,
  },
  userInfoLabel: {
    fontSize: 12,
    color: '#666',
    marginBottom: 4,
  },
  userInfoText: {
    fontSize: 14,
    color: '#333',
    marginBottom: 2,
  },
  actionContainer: {
    width: '100%',
    marginBottom: 24,
  },
  requestButton: {
    backgroundColor: '#FF6B35',
    borderRadius: 4,
    paddingVertical: 14,
    alignItems: 'center',
    marginBottom: 12,
    width: '100%',
  },
  requestButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
  logoutButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 4,
    paddingVertical: 14,
    alignItems: 'center',
    width: '100%',
  },
  logoutButtonText: {
    color: '#666',
    fontSize: 16,
    fontWeight: '500',
  },
  helpText: {
    fontSize: 12,
    textAlign: 'center',
    color: '#999',
    lineHeight: 18,
  },
});